<script setup>
import { formatDialogId } from 'shared/services/ariaReferenceService';
import { computed, ref, onMounted } from 'vue';
import useModalFocusTrap from 'shared/composables/focusTrap';

const props = defineProps({
	modalData: {
		type: Object,
		required: true,
	},
	closeOnEscape: {
		type: Boolean,
		default: true,
	},
	closeLabel: {
		type: String,
		default: 'Close',
	},
});

const emit = defineEmits(['close-modal']);

const modal = ref(null);

let restoreFocus;

onMounted(() => {
	restoreFocus = useModalFocusTrap(modal.value, emit, 'close-modal', props.closeOnEscape).restoreFocus;
});

const modalClass = computed(() => 'c-variant-' + props.modalData.dataName + '-modal');
const wrapperClass = computed(() => 'c-modal__wrapper--' + props.modalData.dataName);
const containerClass = computed(() => 'c-variant-' + props.modalData.dataName + '-modal__modal-container');
const buttonWrapperClass = computed(() => 'c-variant-' + props.modalData.dataName + '-modal__button-wrapper');

const closeModal = () => {
	emit('close-modal');
	restoreFocus();
}

const toCamelcase = (str) => {
	return str.replace(/-./g, x=>x[1].toUpperCase());
}

</script>

<template>
    <div
		data-testid="genericModal"
		ref="modal"
        v-if="modalData"
        :id="formatDialogId(modalData.dataName)"
        role="dialog"
        aria-modal="true"
        :aria-labelledby="formatDialogId(modalData.dataName, 'label')"
        :aria-describedby="formatDialogId(modalData.dataName, 'desc')"
        class="c-modal__mask c-modal__mask--grey"
        :class="modalClass"
        :data-modal="toCamelcase(modalData.dataName)">

        <div
            class="c-modal__wrapper c-modal__wrapper--generic-modal"
            :class="wrapperClass">

            <div
                class="c-modal__container"
                :class="containerClass"
                ref="modalContainer">

                <div>
                    <button
                        class="c-modal__close c-modal__close--grey c-modal__close--generic-modal"
                        @click.prevent="closeModal"
                        :aria-label="props.closeLabel"
                        ></button>

                    <slot name="header"></slot>
                </div>
                <div>
                    <slot name="body"></slot>
                </div>
                <div :class="buttonWrapperClass">
                    <slot name="footer"></slot>
                </div>
            </div>
        </div>
    </div>
</template>
